/*
 * @Author: 吴文洁
 * @Date: 2019-09-19 14:27:09
 * @LastEditors: fusanqiasng
 * @LastEditTime: 2022-10-20 11:04:17
 * @Description:
 */
import Service from './Service';
import User from '../core/user';

class UserService {
  constructor(props) {
    this.PATH = {
      USER_INFO: 'public/user/getUserInfoById',
      MODIFY_USER_NAME: 'public/user/modifyBaseInfoByUserId',
      MODIFY_USER_AVATAR: 'public/user/modifyBaseInfoByUserId',
      USER_ATTENTION_INSTITIONS: 'public/institution/getAttentionInstitutionList',
      USER_SET_DEFAULT_INSTITION: 'c/institution/setDefaultInstitution',
      USER_RELEVANT_STUDENTS: 'c/user/getRelevanceList',
      NEW_USER_RELEVANT_STUDENTS: 'public/customerIntegral/integralStudent',
      USER_COURSE_PERMISSION: 'public/institution/getLookClass',
      GET_BINDLIST: 'customer/public/groupToStudent/bindList',
      GET_MERGE_BIND_STUDENT: 'public/groupToStudent/mergeBindList',
      UNBIND_STUDENT: 'customer/public/groupToStudent/deleteByIds',
      CHECK_OLD_USER_LOGIN: 'c/archives/dynamic/judgeFirstLogin',
      RECHARGE_PERMISSION: 'public/institution/getBalanceRule',
      GET_INSTNAME: 'public/institution/detail',
      RELATED_STUDENT: 'public/mall/fetchRelatedStudentList',
    };
  }

  getInstNameById(instId) {
    return axios.Customer(this.PATH.GET_INSTNAME, { instId });
  }

  getUserInfo() {
    return axios.Customer(this.PATH.USER_INFO, {
      appId: User.appId() || '',
      userId: User.uid() || '',
    });
  }

  getRechargePermission() {
    return axios.Customer(this.PATH.RECHARGE_PERMISSION, {});
  }

  modifyUserName(name) {
    return axios.Customer(this.PATH.MODIFY_USER_NAME, {
      nickName: name,
      userId: User.uid(),
    });
  }

  modifyUserAvatar(avatar) {
    return axios.Customer(this.PATH.MODIFY_USER_AVATAR, {
      avatarUrl: avatar,
      userId: User.uid(),
    });
  }

  //获取用户关注的机构列表
  getAttentionInsts() {
    return axios.Customer(this.PATH.USER_ATTENTION_INSTITIONS, {});
  }

  setDefaultInstition(instId) {
    return Service.doAsyncRequest(this.PATH.USER_SET_DEFAULT_INSTITION, {
      params: { instId: instId },
    });
  }

  getRelevantStudent(options) {
    return Service.doAsyncRequest(this.PATH.USER_RELEVANT_STUDENTS, {
      params: {},
      ...options,
    });
  }

  getNewRelevantStudent(params) {
    return axios.Sales(this.PATH.NEW_USER_RELEVANT_STUDENTS, params);
  }

  getCoursePermission() {
    return axios.Customer(this.PATH.USER_COURSE_PERMISSION, {});
  }

  // 获取关联学员列表
  getBindList(appId) {
    return Service.doAsyncRequest(this.PATH.GET_BINDLIST, {
      params: JSON.stringify({ appId }),
      contentType: 'application/json; charset=UTF-8',
      heimdall: true,
    });
  }

  getMergeBindStudentList(appId, platform) {
    return axios.Customer(this.PATH.GET_MERGE_BIND_STUDENT, {
      appId,
      platform,
    });
  }
  // 在线商城-确认订单-获取学生
  getReletedStundentList(appId, platform, commodityId) {
    return axios.Customer(this.PATH.RELATED_STUDENT, {
      appId,
      platform,
      commodityId,
    });
  }
  // 解绑学员
  unbindStudent(ids) {
    const params = {
      ids: [ids],
    };
    return Service.doAsyncRequest(this.PATH.UNBIND_STUDENT, {
      params: JSON.stringify(params),
      contentType: 'application/json; charset=UTF-8',
      heimdall: true,
    });
  }

  // 判断老用户是否是第一次登录
  checkOldUserFirstLogin() {
    return Service.doAsyncRequest(this.PATH.CHECK_OLD_USER_LOGIN, {
      params: {},
    });
  }

  /**
   * 判断id是否是5.0机构
   * @param {Number} instId 机构id
   * @returns true是5.0机构，否则不是
   */
  async isInstV5(instId) {
    const bindStudentList = (await this.getBindList(User.appId())).result;
    if (bindStudentList && bindStudentList.length > 0) {
      for (const student of bindStudentList) {
        if (student.instId == instId) {
          return student.saasVersion == 'V_50';
        }
      }
    }
    return false;
  }
  /**
   * 判断是否是用户绑定的学生
   * @param {Number} studentId 学员Id
   * @returns true表示是，否则不是
   */
  async isUserBindStudent(studentId) {
    const bindStudentList = (await this.getBindList(User.appId())).result;
    if (bindStudentList && bindStudentList.length > 0) {
      for (const student of bindStudentList) {
        if (student.studentId == studentId) {
          return true;
        }
      }
    }
    return false;
  }
}

export default new UserService();



// WEBPACK FOOTER //
// ./src/service/UserService.js